import React from 'react';
import { Home, Grid, Search, Bookmark, Compass, User } from 'lucide-react';
import { AppView } from '../../types';

interface MobileBottomBarProps {
  currentView: AppView;
  onNavigate: (view: AppView) => void;
  onOpenSearch: () => void;
  onOpenWorkspace: () => void;
  onOpenAuthModal: () => void;
  savedCount: number;
  isLoggedIn: boolean;
}

export const MobileBottomBar: React.FC<MobileBottomBarProps> = ({
  currentView,
  onNavigate,
  onOpenSearch,
  onOpenWorkspace,
  onOpenAuthModal,
  savedCount,
  isLoggedIn,
}) => {
  return (
    <nav 
      aria-label="Mobile bottom navigation"
      className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-white/95 backdrop-blur-md border-t border-[#E5E7EB] px-3 pt-2 pb-[max(0.6rem,env(safe-area-inset-bottom))] flex items-center justify-around shadow-lg"
    >
      <button
        onClick={() => onNavigate('homepage')}
        className={`flex flex-col items-center gap-1 p-1 text-xs font-semibold ${
          currentView === 'homepage' ? 'text-[#1A1A1A]' : 'text-[#6B7280]'
        }`}
      >
        <Home className="w-5 h-5" />
        <span className="text-[10px]">Home</span>
      </button>

      <button
        onClick={() => onNavigate('tools')}
        className={`flex flex-col items-center gap-1 p-1 text-xs font-semibold ${
          currentView === 'tools' ? 'text-[#1A1A1A]' : 'text-[#6B7280]'
        }`}
      >
        <Grid className="w-5 h-5" />
        <span className="text-[10px]">Tools</span>
      </button>

      <button
        onClick={onOpenSearch}
        className="flex flex-col items-center gap-1 p-1 text-xs font-semibold text-[#6B7280]"
      >
        <div className="w-8 h-8 rounded-full bg-[#1A1A1A] text-white flex items-center justify-center -mt-3 shadow-md">
          <Search className="w-4 h-4" />
        </div>
        <span className="text-[10px]">Search</span>
      </button>

      <button
        onClick={() => onNavigate('discovery')}
        className={`flex flex-col items-center gap-1 p-1 text-xs font-semibold ${
          currentView === 'discovery' ? 'text-[#1A1A1A]' : 'text-[#6B7280]'
        }`}
      >
        <Compass className="w-5 h-5" />
        <span className="text-[10px]">Discovery</span>
      </button>

      {isLoggedIn ? (
        <button
          onClick={onOpenWorkspace}
          className="flex flex-col items-center gap-1 p-1 text-xs font-semibold text-[#6B7280] relative cursor-pointer"
        >
          <Bookmark className="w-5 h-5" />
          {savedCount > 0 && (
            <span className="absolute top-0 right-2 w-3.5 h-3.5 bg-[#1A1A1A] text-white rounded-full text-[8px] font-bold flex items-center justify-center">
              {savedCount}
            </span>
          )}
          <span className="text-[10px]">Workspace</span>
        </button>
      ) : (
        <button
          onClick={onOpenAuthModal}
          className="flex flex-col items-center gap-1 p-1 text-xs font-semibold text-[#1A1A1A] cursor-pointer"
        >
          <User className="w-5 h-5" />
          <span className="text-[10px]">Sign In</span>
        </button>
      )}
    </nav>
  );
};
